import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "ui-rail-panel" }
const _hoisted_3 = { class: "ui-rail-slot" }
const _hoisted_4 = { class: "ui-rail-brand" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ui-rail-label ui-rail-title" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "ui-rail-nav" }
const _hoisted_9 = {
  key: 0,
  class: "ui-rail-sep ui-rail-sep-sm",
  "aria-hidden": "true"
}
const _hoisted_10 = ["aria-label", "aria-expanded", "onClick"]
const _hoisted_11 = { class: "ui-rail-slot" }
const _hoisted_12 = { class: "ui-rail-bubble" }
const _hoisted_13 = { class: "ui-rail-label" }
const _hoisted_14 = { class: "ui-rail-sub" }
const _hoisted_15 = { class: "ui-rail-slot" }
const _hoisted_16 = { class: "ui-rail-bubble" }
const _hoisted_17 = { class: "ui-rail-label" }
const _hoisted_18 = ["aria-label", "aria-hidden"]
const _hoisted_19 = { class: "ui-drawer-head" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = {
  key: 0,
  class: "ui-drawer-loading"
}
const _hoisted_23 = { class: "ui-drawer-nav" }
const _hoisted_24 = ["aria-expanded", "onClick"]
const _hoisted_25 = { class: "ui-drawer-icon" }
const _hoisted_26 = { class: "ui-drawer-label" }
const _hoisted_27 = { class: "ui-drawer-sub" }
const _hoisted_28 = { class: "ui-drawer-icon" }
const _hoisted_29 = { class: "ui-drawer-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      ref: "railEl",
      class: _normalizeClass(["ui-rail", { expanded: _ctx.railExpanded }]),
      "aria-label": _ctx.$t('sidebar.mainNav'),
      onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandRail && _ctx.expandRail(...args))),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.collapseRail && _ctx.collapseRail(...args))),
      onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.expandRail && _ctx.expandRail(...args))),
      onFocusout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onRailFocusOut && _ctx.onRailFocusOut(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "ui-rail-head",
          "aria-label": _ctx.$t('header.home')
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.logoSrc,
                  alt: ""
                }, null, 8, _hoisted_5)
              ])
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("sidebar.mainMenu")), 1)
          ]),
          _: 1
        }, 8, ["aria-label"]),
        _cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "ui-rail-sep",
          "aria-hidden": "true"
        }, null, -1)),
        (_ctx.permsLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ui-rail-loading",
              "aria-label": _ctx.$t('sidebar.loadingMenu')
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)
            ]), 8, _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("nav", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenu, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.key
            }, [
              (item.separatorBefore && index > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                : _createCommentVNode("", true),
              (item.children)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["ui-rail-link", { active: _ctx.isItemActive(item), open: _ctx.railExpanded && _ctx.railGroup === item.key }]),
                      "aria-label": _ctx.$t(item.label),
                      "aria-expanded": _ctx.railExpanded && _ctx.railGroup === item.key,
                      onClick: ($event: any) => (_ctx.toggleRailGroup(item))
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createElementVNode("i", {
                            class: _normalizeClass(item.icon),
                            "aria-hidden": "true"
                          }, null, 2),
                          _cache[7] || (_cache[7] = _createElementVNode("span", {
                            class: "ui-rail-caret",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(item.label)), 1),
                      _cache[8] || (_cache[8] = _createElementVNode("i", {
                        class: "ph ph-caret-down ui-rail-chevron",
                        "aria-hidden": "true"
                      }, null, -1))
                    ], 10, _hoisted_10),
                    _withDirectives(_createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: child.to,
                          to: child.to,
                          class: _normalizeClass(["ui-rail-sublink", { active: _ctx.isPathActive(child.to) }]),
                          "aria-current": _ctx.isPathActive(child.to) ? 'page' : undefined
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(child.icon),
                              "aria-hidden": "true"
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(child.label)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class", "aria-current"]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.railExpanded && _ctx.railGroup === item.key]
                    ])
                  ], 64))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: item.to,
                    class: _normalizeClass(["ui-rail-link", { active: _ctx.isItemActive(item) }]),
                    "aria-label": _ctx.$t(item.label),
                    "aria-current": _ctx.isItemActive(item) ? 'page' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createElementVNode("i", {
                            class: _normalizeClass(item.icon),
                            "aria-hidden": "true"
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(item.label)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "aria-label", "aria-current"]))
            ], 64))
          }), 128))
        ])
      ])
    ], 42, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["ui-drawer-backdrop", { show: _ctx.stateStoreInstance.open }]),
      "aria-hidden": "true",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleRouteClick && _ctx.handleRouteClick(...args)))
    }, null, 2),
    _createElementVNode("aside", {
      class: _normalizeClass(["ui-drawer", { open: _ctx.stateStoreInstance.open }]),
      "aria-label": _ctx.$t('sidebar.mainNav'),
      "aria-hidden": !_ctx.stateStoreInstance.open
    }, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "ui-drawer-brand",
          "aria-label": _ctx.$t('header.home')
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.logoSrc,
              alt: ""
            }, null, 8, _hoisted_20)
          ]),
          _: 1
        }, 8, ["aria-label"]),
        _createElementVNode("button", {
          type: "button",
          class: "ui-icon-btn",
          "aria-label": _ctx.$t('sidebar.closeMenu'),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleRouteClick && _ctx.handleRouteClick(...args)))
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("i", {
            class: "ph ph-x",
            "aria-hidden": "true"
          }, null, -1)
        ]), 8, _hoisted_21)
      ]),
      (_ctx.permsLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("sidebar.loadingMenu")) + "… ", 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", _hoisted_23, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenu, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.key
          }, [
            (item.children)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["ui-drawer-link", { active: _ctx.isItemActive(item) }]),
                    "aria-expanded": _ctx.drawerGroup === item.key,
                    onClick: ($event: any) => (_ctx.drawerGroup = _ctx.drawerGroup === item.key ? null : item.key)
                  }, [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon),
                        "aria-hidden": "true"
                      }, null, 2)
                    ]),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t(item.label)), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["ph ph-caret-down ui-drawer-caret", { rotated: _ctx.drawerGroup === item.key }]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ], 10, _hoisted_24),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: child.to,
                        to: child.to,
                        class: _normalizeClass(["ui-drawer-sublink", { active: _ctx.isPathActive(child.to) }])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(child.label)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.drawerGroup === item.key]
                  ])
                ], 64))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: item.to,
                  class: _normalizeClass(["ui-drawer-link", { active: _ctx.isItemActive(item) }]),
                  "aria-current": _ctx.isItemActive(item) ? 'page' : undefined
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_28, [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon),
                        "aria-hidden": "true"
                      }, null, 2)
                    ]),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t(item.label)), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class", "aria-current"]))
          ], 64))
        }), 128))
      ])
    ], 10, _hoisted_18)
  ], 64))
}